import {
	CATEGORIES_GET_STATUS,
	CATEGORIES_GET,
	CATEGORIES_GET_ERROR,
	CATEGORIES_GET_BY_ID,
	CATEGORIES_CLEAR,
	CATEGORY_GET_STATUS,
	CATEGORY_GET,
	CATEGORY_GET_ERROR,
	CATEGORY_RESOURCES_GET_STATUS,
	CATEGORY_RESOURCES_GET,
	CATEGORY_RESOURCES_GET_ERROR,
	BREAD_CRUMBS_SET,
	BREAD_CRUMBS_SET_STATUS,
	RESOURCE_GET,
	RESOURCE_GET_ERROR,
	RESOURCE_CLEAR,
	RESOURCE_TOGGLE_VIEW,
	RESOURCE_GET_TYPES_LIST,
	RESOURCE_GET_TYPES_LIST_ERROR,
	RESOURCE_GET_AUTHORS_LIST,
	RESOURCE_GET_AUTHORS_LIST_ERROR,
	RESOURCE_TOGGLE_DEFAULT_VIEW,
} from './types'

const initialState = {
	isLoading: false,
	list: [],
	total: 0,
	resource: null,

	listMeta: null,
	singleMeta: null,

	breadCrumbs: [],

	category: null,
	categoryResources: [],
	resourcesTagErrors: null,

	resourcesType: [],
	resourcesTypeErrors: null,
	resourcesTypeMeta: null,

	authors: [],
	authorsMeta: null,
	authorErrors: null,

	listView: true,

	errors: null,
}

export const state = { ...initialState }

export default {
	[RESOURCE_GET_AUTHORS_LIST](state, payload) {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.authors = [...data]
		state.authorsMeta = {
			pageCount: Number(pageCount),
			perPage: Number(perPage),
			totalCount: Number(totalCount),
			currentPage: Number(currentPage),
		}
	},
	[RESOURCE_GET_AUTHORS_LIST_ERROR](state, error) {
		state.authorErrors = error
	},
	[RESOURCE_GET_TYPES_LIST](state, types) {
		state.resourcesType = Object.entries(types).map(([key, value]) => ({
			id: parseInt(key),
			name: value,
		}))

		if (types.resourcesTypeMeta) {
			state.resourcesTypeMeta = { ...types.resourcesTypeMeta }
		}
	},

	[RESOURCE_GET_TYPES_LIST_ERROR](state, error) {
		state.resourcesTagErrors = error
	},
	[CATEGORIES_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[CATEGORY_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[BREAD_CRUMBS_SET_STATUS]: (state, status) => {
		state.isLoading = status
	},
	[CATEGORY_RESOURCES_GET_STATUS]: (state, status) => {
		state.isLoading = status
	},

	[BREAD_CRUMBS_SET]: (state, items) => {
		state.breadCrumbs = [...state.breadCrumbs, ...items]
	},

	[CATEGORIES_GET]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.list = data

		state.listMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORIES_GET_BY_ID]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.list = data

		state.singleMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORIES_CLEAR]: (state) => {
		state.list = []
	},
	[CATEGORY_GET]: (state, { data, pageCount, perPage, totalCount, currentPage }) => {
		state.category = data

		state.singleMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},
	[CATEGORY_RESOURCES_GET]: (state, resources) => {
		state.categoryResources = resources
	},

	[CATEGORY_RESOURCES_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[CATEGORY_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[CATEGORIES_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[RESOURCE_GET]: (state, resource) => {
		state.resource = resource
	},
	[RESOURCE_CLEAR]: (state) => {
		state.resource = null
	},
	[RESOURCE_GET_ERROR]: (state, errors) => {
		state.errors = errors
	},
	[RESOURCE_TOGGLE_VIEW]: (state) => {
		state.listView = !state.listView
	},
	[RESOURCE_TOGGLE_DEFAULT_VIEW]: (state) => {
		state.listView = true
	},
}
